// S3 Configuration
export const BASE_IMAGE_URL = process.env.NEXT_PUBLIC_S3_BASE_URL;
export const BASE_TERMS_URL = process.env.NEXT_PUBLIC_S3_TEMRS_URL;
